/* eslint-disable sort-keys */
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/
export default ({ palette, screenSizes }) => ({
  '*, ::after, ::before': {
    boxSizing: 'border-box',
    outline: 'none',
    textSizeAdjust: '100%',
  },
  '*[tabindex="-1"]': {
    outline: 'none',
  },
  '.ReactCollapse--collapse': {
    transition: 'height 250ms',
  },
  '.hidden': {
    display: 'none',
  },
  '.is-hidden': {
    left: -1000,
    lineHeight: 0,
    margin: 0,
    position: 'fixed',
    textIndent: -999999,
    top: -1000,
  },
  '.modal-open': {
    overflow: 'hidden',
  },
  '@keyframes load': {
    from: {
      transform: 'rotate(0deg)',
      transformOrigin: '50% 50%',
    },
    to: {
      transform: 'rotate(360deg)',
      transformOrigin: '50% 50%',
    },
  },
  'a:focus, input[type="radio"]:focus + label, input[type="checkbox"]:focus + label, button:focus, div[role="button"]:focus': {
    boxShadow: `0 0 1px 1px ${palette.form.active} !important`,
  },
  'article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section': {
    display: 'block',
  },
  'blockquote, q': {
    quotes: 'none',
  },
  'blockquote:before, blockquote:after, q:before, q:after': {
    content: '',
  },
  body: {
    lineHeight: 1,
  },
  'html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video': {
    border: 0,
    font: 'inherit',
    fontSize: '100%',
    margin: 0,
    padding: 0,
    verticalAlign: 'baseline',
  },
  'input:focus, input:focus + input, select:focus': {
    boxShadow: `1px 1px 1px ${palette.form.active} !important`,
  },
  'ol, ul': {
    listStyle: 'none',
  },
  table: {
    borderCollapse: 'collapse',
    borderSpacing: 0,
  },
  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
    '#root': {
      overflowX: 'hidden',
    },
  },
});
